import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import { ref } from "vue";
// import { httpGet } from "@/utils/http";
import { usePermissionRouterStore } from "@/store/permissionRouter";

const constantRoutes = [
  {
    name: "chat-export",
    path: "/chat/export",
    meta: { title: "导出会话记录" },
    component: () => import("@/views/ChatExport.vue"),
  },
  {
    name: "login",
    path: "/login",
    meta: { title: "用户登录" },
    component: () => import("@/views/Login.vue"),
  },
    {
    name: "wxLogin",
    path: "/wxLogin",
    meta: { title: "微信登录" },
    component: () => import("@/views/WxLogin.vue"),
  },
  {
    name: "login-callback",
    path: "/login/callback",
    meta: { title: "用户登录" },
    component: () => import("@/views/LoginCallback.vue"),
  },
  {
    name: "register",
    path: "/register",

    meta: { title: "用户注册" },
    component: () => import("@/views/Register.vue"),
  },
  {
    name: "webgl-add",
    path: "/webgl-add",
    meta: {
      title: "VR",
      menu: false,
    },
    component: () => import("@/views/webGlManager/addWebGl.vue"),
  },
  {
    name: "webgl-edit",
    path: "/webgl-edit",
    meta: {
      title: "VR",
      menu: false,
    },
    component: () => import("@/views/webGlManager/editWebGl.vue"),
  },
  {
    name: "webgl-view",
    path: "/webgl-view",
    meta: {
      title: "VR",
      menu: false,
    },
    component: () => import("@/views/webGlManager/webGlView.vue"),
  },

  {
    name: "test",
    path: "/test",
    meta: { title: "测试页面" },
    component: () => import("@/views/Test.vue"),
  },
  {
    name: "NotFound",
    path: "/:all(.*)",
    meta: { title: "页面没有找到" },
    component: () => import("@/views/404.vue"),
  },
];

/**单独记录左侧菜单路由，已经完成了和后端动态对接*/
const menuRoutesMapSuccess = [
  // {
  //   name: "chat",
  //   path: "/chat",
  //   meta: { title: "创作中心" },
  //   component: () => import("@/views/ChatPlus.vue"),
  // },
  // {
  //   name: "aiChangeClothes",
  //   path: "/aiChangeClothes",
  //   meta: { title: "AI换装" },
  //   component: () => import("@/views/AiChangeClothes/index.vue"),
  // },
  // {
  //   name: "digitalHumanFront",
  //   path: "/digitalHumanFront",
  //   meta: { title: "数字人" },
  //   component: () => import("@/views/digitalHuman/digitalHumanResult.vue"),
  // },
  // {
  //   name: "speechSynthesis",
  //   path: "/speechSynthesis",
  //   meta: { title: "语音合成", menu: true },
  //   component: () => import("@/views/speechSynthesis/speechSynthesis.vue"),
  // },
  // {
  //   name: "personalCenter",
  //   path: "/personalCenter",
  //   meta: {
  //     title: "个人中心",
  //     menu: true,
  //   },
  //   component: () => import("@/views/personalCenter/personalCenter.vue"),
  // },
  // {
  //   name: "knowledgeBase",
  //   path: "/knowledgeBase",
  //   meta: {
  //     title: "知识库",
  //     menu: true,
  //   },
  //   component: () => import("@/views/knowledgeBase/knowledgeBase.vue"),
  // },
  // {
  //   name: "webgl-list",
  //   path: "/webgl-list",
  //   meta: {
  //     title: "VR",
  //     menu: true,
  //   },
  //   component: () => import("@/views/webGlManager/list.vue"),
  // },
  // {
  //   name: "scene-list",
  //   path: "/scene-list",
  //   meta: {
  //     title: "场景编排",
  //     menu: true,
  //   },
  //   component: () =>
  //     import("@/views/sceneArrangementManager/sceneList.vue"),
  // },
  // {
  //   name: 'soundCloning-list',
  //   path: '/soundCloning-list',
  //   meta: {
  //     title: '声音克隆',
  //     menu: true,
  //   },
  //   component: ()=>import('@/views/soundCloning/soundCloningList.vue')
  // },
];

export const layoutRoutes = [
  // {
  //   name: "Index",
  //   path: "/",
  //   meta: { title: "首页" },
  //   component: () => import("@/views/Index.vue"),
  // },
  {
    name: "home",
    path: "/",
    redirect: "/chat",
    component: () => import("@/layout/index.vue"),
    // component: () => import("@/views/Home.vue"),
    children: [
      {
        name: "image-mj",
        path: "/mj",
        meta: { title: "MidJourney 绘画中心" },
        component: () => import("@/views/ImageMj.vue"),
      },
      {
        name: "image-sd",
        path: "/sd",
        meta: { title: "stable diffusion 绘画中心" },
        component: () => import("@/views/ImageSd.vue"),
      },
      {
        name: "member",
        path: "/member",
        meta: { title: "会员充值中心" },
        component: () => import("@/views/Member.vue"),
      },
      {
        name: "chat-app",
        path: "/apps",
        meta: { title: "应用中心" },
        component: () => import("@/views/ChatApps.vue"),
      },
      {
        name: "images",
        path: "/images-wall",
        meta: { title: "作品展示" },
        component: () => import("@/views/ImagesWall.vue"),
      },
      {
        name: "user-invitation",
        path: "/invite",
        meta: { title: "推广计划" },
        component: () => import("@/views/Invitation.vue"),
      },
      {
        name: "powerLog",
        path: "/powerLog",
        meta: { title: "消费日志" },
        component: () => import("@/views/PowerLog.vue"),
      },
      {
        name: "xmind",
        path: "/xmind",
        meta: { title: "思维导图" },
        component: () => import("@/views/MarkMap.vue"),
      },

      {
        name: "speechSynthesis-add",
        path: "/speechSynthesis-add",
        meta: { title: "添加语音", menu: false },
        component: () =>
          import("@/views/speechSynthesis/addSpeechSynthesis.vue"),
      },
      {
        name: "digitalHuman",
        path: "/digitalHuman",
        meta: { title: "数字人" },
        component: () => import("@/views/digitalHuman/index.vue"),
      },
      // {
      //   name: "liveStreamingScene",
      //   path: "/liveStreamingScene",
      //   meta: { title: "直播场景" },
      //   component: () => import("@/views/liveStreamingScene/index.vue"),
      // },
      {
        name: "liveStreamingSceneAfter",
        path: "/liveStreamingSceneAfter/:id",
        meta: { title: "场景选择" },
        component: () =>
          import("@/views/liveStreamingScene/liveStreamingSceneAfter.vue"),
      },
      {
        name: "questionAndAnswerLibrary",
        path: "/questionAndAnswerLibrary/:id",
        meta: { title: "问答库" },
        component: () => import("@/views/questionAndAnswerLibrary/index.vue"),
      },
      {
        name: "scriptTemplateLibrary",
        path: "/scriptTemplateLibrary/:id",
        meta: { title: "话术库" },
        component: () => import("@/views/scriptTemplateLibrary/index.vue"),
      },
      {
        name: "virtualHuman",
        path: "/virtualHuman",
        meta: { title: "虚拟模特" },
        component: () => import("@/views/virtualHuman/virtualHuman.vue"),
      },
      // {
      //   name: "textGeneratedImages",
      //   path: "/textGeneratedImages",
      //   meta: { title: "文生图" },
      //   component: () => import("@/views/textGeneratedImages/textGeneratedImages.vue"),
      // },
      {
        name: "textGeneratedVideo",
        path: "/textGeneratedVideo",
        meta: { title: "文生视频" },
        component: () =>
          import("@/views/textGeneratedVideo/textGeneratedVideo.vue"),
      },
      {
        name: "imageGeneratedVideo",
        path: "/imageGeneratedVideo",
        meta: { title: "图生视频" },
        component: () =>
          import("@/views/imageGeneratedVideo/imageGeneratedVideo.vue"),
      },
      {
        name: "dalle",
        path: "/dalle",
        meta: { title: "DALLE-3" },
        component: () => import("@/views/Dalle.vue"),
      },
      {
        name: "ExternalLink",
        path: "/external",
        component: () => import("@/views/ExternalPage.vue"),
      },
      // {
      //   name: "ApplicationSquare",
      //   path: "/applicationSquare",
      //   meta: { title: "应用广场" },
      //   component: () =>
      //     import("@/views/applicationSquare/ApplicationSquare.vue"),
      // },
      {
        name: "Interviewer",
        path: "/interviewer",
        meta: { title: "应用广场-场景" },
        component: () => import("@/views/applicationSquare/Interviewer.vue"),
      },
      {
        name: "DocumentChange",
        path: "/documentChange",
        meta: { title: "文档转换" },
        component: () => import("@/views/DocumentChange.vue"),
      },
      // {
      //   name: "TiktokTalent",
      //   path: "/tiktokTalent",
      //   meta: { title: "抖音达人" },
      //   component: () => import("@/views/tiktokTalent/tiktokTalent.vue"),
      // },

      {
        name: "soundCloning-add",
        path: "/soundCloning-add",
        meta: {
          title: "添加声音克隆",
          menu: false,
        },
        component: () => import("@/views/soundCloning/addSoundCloning.vue"),
      },
      {
        name: "theDigitalHumanNew-add",
        path: "/theDigitalHumanNew-add",
        meta: {
          title: "添加新数字人",
        },
        component: () =>
          import("@/views/theDigitalHumanNew/addTheDigitalHumanNew.vue"),
      },
      {
        name: "speechRecognition-list",
        path: "/speechRecognition-list",
        meta: {
          title: "语音识别",
        },
        component: () => import("@/views/speechRecognition/speechRecognition.vue"),
      },
            {
        name: "modelHandle",
        path: "/modelHandle",
        meta: {
          title: "模型压缩",
        },
        component: () => import("@/views/modelHandle/indexPage.vue"),
      },
    ],
  },
];

// console.log(MY_VARIABLE)
const router = createRouter({
  history: createWebHistory(), // createWebHashHistory(), //
  routes: [...constantRoutes, ...layoutRoutes],
});

const active = ref(false);
const title = ref("");

const whiteRoutes = ["/login", "/register", "/webgl-view", "/test", "/wxLogin"];

// httpGet("/api/config/license")
//   .then((res) => {
//     active.value = res.data.de_copy;
//   })
//   .catch(() => {});
// httpGet("/api/config/get?key=system")
//   .then((res) => {
//     title.value = res.data.title;
//   })
//   .catch(() => {});

let prevRoute = null;
// dynamic change the title when router change
router.beforeEach(async (to, from, next) => {
  console.log("Before each hook triggered");
  if (!active.value) {
    document.title = `${to.meta.title} | ${process.env.VUE_APP_TITLE}`;
  } else {
    document.title = `${to.meta.title} | ${title.value}`;
  }
  prevRoute = from;
  console.log("Current route:", to);

  if (!whiteRoutes.includes(to.path)) {
    const permissionRouterStore = usePermissionRouterStore();
    if (!permissionRouterStore.permissionRouter?.length) {
      await permissionRouterStore.initPermissionRouter(router);
      next(to.fullPath);
    } else {
      next();
    }
  } else {
    next();
  }
});
export { router, prevRoute };
